export enum PropertyType {
  OFFICETEL = 'OFFICETEL', // 오피스텔
  APARTMENT = 'APARTMENT', // 아파트
  STUDIO = 'STUDIO', // 원룸건물
  VILLA = 'VILLA', // 연립빌라
  DETACHED = 'DETACHED', // 단독주택
  MIXED_USE = 'MIXED_USE', // 상가주택
  GUEST_HOUSE = 'GUEST_HOUSE', // 게스트 하우스
  HOTEL = 'HOTEL', // 호텔
  MOTEL = 'MOTEL', // 모텔여관
  VACATION_HOME = 'VACATION_HOME', // 펜션
  GOSIWON = 'GOSIWON', // 고시원
  SHARE_HOUSE = 'SHARE_HOUSE', // 쉐어 하우스
}

export enum BasicOption {
  REFRIGERATOR = 'REFRIGERATOR', // 냉장고
  WASHING_MACHINE = 'WASHING_MACHINE', // 세탁기
  AIR_CONDITIONER = 'AIR_CONDITIONER', // 에어컨
  TV = 'TV', // TV
  WIFI = 'WIFI', // 와이파이
  SINK = 'SINK', // 싱크대
  GAS_STOVE = 'GAS_STOVE', // 가스레인지
  INDUCTION = 'INDUCTION', // 인덕션
  BED = 'BED', // 침대
}

export enum AdditionalOption {
  DOOR_LOCK = 'DOOR_LOCK', // 도어락
  CCTV = 'CCTV', // CCTV
  MANAGEMENT_OFFICE = 'MANAGEMENT_OFFICE', // 관리실
  DINING_TABLE = 'DINING_TABLE', // 식탁
  MICROWAVE = 'MICROWAVE', // 전자레인지
  RICE_COOKER = 'RICE_COOKER', // 전기밥솥
  WATER_PURIFIER = 'WATER_PURIFIER', // 정수기
  SOFA = 'SOFA', // 소파
  DESK = 'DESK', // 책상
  CLOSET = 'CLOSET', // 옷장
  SHOE_RACK = 'SHOE_RACK', // 신발장
  VANITY = 'VANITY', // 화장대
  BATHTUB = 'BATHTUB', // 욕조
  BIDET = 'BIDET', // 비데
  DRYER = 'DRYER', // 건조기
  BALCONY = 'BALCONY', // 발코니
  DRESSING_ROOM = 'DRESSING_ROOM', // 드레스룸
  CABLE_TV = 'CABLE_TV', // 케이블 TV
  CURTAINS = 'CURTAINS', // 커튼
  AIR_PURIFIER = 'AIR_PURIFIER', // 공기청정기
  PET_ALLOWED = 'PET_ALLOWED', // 반려동물 동반
}

export enum OldAdditionalOption {
  // AdditionalOption
  DOOR_LOCK = 'DOOR_LOCK', // 도어락
  CCTV = 'CCTV', // CCTV
  MANAGEMENT_OFFICE = 'MANAGEMENT_OFFICE', // 관리실
  DINING_TABLE = 'DINING_TABLE', // 식탁
  MICROWAVE = 'MICROWAVE', // 전자레인지
  RICE_COOKER = 'RICE_COOKER', // 전기밥솥
  WATER_PURIFIER = 'WATER_PURIFIER', // 정수기
  SOFA = 'SOFA', // 소파
  DESK = 'DESK', // 책상
  CLOSET = 'CLOSET', // 옷장
  SHOE_RACK = 'SHOE_RACK', // 신발장
  VANITY = 'VANITY', // 화장대
  BATHTUB = 'BATHTUB', // 욕조
  BIDET = 'BIDET', // 비데
  DRYER = 'DRYER', // 건조기
  BALCONY = 'BALCONY', // 발코니
  DRESSING_ROOM = 'DRESSING_ROOM', // 드레스룸
  CABLE_TV = 'CABLE_TV', // 케이블 TV
  CURTAINS = 'CURTAINS', // 커튼
  AIR_PURIFIER = 'AIR_PURIFIER', // 공기청정기
  // OldAdditionalOption Only
  COOLING_HEATING_SYSTEM = 'COOLING_HEATING_SYSTEM', // 냉난방기
  HEATER = 'HEATER', // 히터
  IRON = 'IRON', // 다리미
  ELECTRIC_KETTLE = 'ELECTRIC_KETTLE', // 전기포트
  TABLEWARE = 'TABLEWARE', // 식기류
  COOKWARE = 'COOKWARE', // 조리도구
  HAIR_DRYER = 'HAIR_DRYER', // 드라이기
}

export enum ParkingType {
  FREE_LEEWAY = 'FREE_LEEWAY', // 무료 주차 (여유)
  FREE_FIRST_COME = 'FREE_FIRST_COME', // 무료 주차 (선착순)
  PAID = 'PAID', // 유료 주차
  NONE = 'NONE', // 불가능
}

export enum RefundPolicy {
  SOFT = 'SOFT',
  MIDDLE = 'MIDDLE',
  STRONG = 'STRONG',
}

export enum RoomScheduleStatus {
  BOOKING = 'booking',
  DISABLE = 'disable',
}

export enum RoomStatus {
  DRAFT = 'DRAFT', // 작성 중
  REVIEW = 'REVIEW', // 검토 중
  REGISTERED = 'REGISTERED', // 등록됨
  REJECT = 'REJECT', // 보류됨
  DELETED = 'DELETED', // 삭제됨
}

export enum RoomSortOption {
  POPULAR = 'POPULAR',
  LOW_PRICE = 'LOW_PRICE',
  HIGH_PRICE = 'HIGH_PRICE',
  RECENT = 'RECENT',
}
